import(/* webpackMode: "eager" */ "/app/packages/apps/maui/app/(public)/error.tsx");
